
const STORAGE_KEYS = {
  USER_NAME: 'miiglu_user_name',
  RECENT_MEETINGS: 'miiglu_recent_meetings',
  PREFERENCES: 'miiglu_preferences',
} as const;

/**
 * Save user name to local storage
 */
export function saveUserName(name: string): void {
  try {
    localStorage.setItem(STORAGE_KEYS.USER_NAME, name);
  } catch (error) {
    console.error('Failed to save user name:', error);
  }
}

/**
 * Get saved user name
 */
export function getSavedUserName(): string | null {
  try {
    return localStorage.getItem(STORAGE_KEYS.USER_NAME);
  } catch (error) {
    console.error('Failed to get user name:', error);
    return null;
  }
}

/**
 * Save recent meeting
 */
export function saveRecentMeeting(meetingId: string, title: string): void {
  try {
    const recent = getRecentMeetings();
    const newMeeting = {
      id: meetingId,
      title,
      timestamp: new Date().toISOString(),
    };

    const updated = [newMeeting, ...recent.filter(m => m.id !== meetingId)].slice(0, 5);
    localStorage.setItem(STORAGE_KEYS.RECENT_MEETINGS, JSON.stringify(updated));
  } catch (error) {
    console.error('Failed to save recent meeting:', error);
  }
}

/**
 * Get recent meetings
 */
export function getRecentMeetings(): Array<{
  id: string;
  title: string;
  timestamp: string;
}> {
  try {
    const data = localStorage.getItem(STORAGE_KEYS.RECENT_MEETINGS);
    return data ? JSON.parse(data) : [];
  } catch (error) {
    console.error('Failed to get recent meetings:', error);
    return [];
  }
}

/**
 * Clear all storage
 */
export function clearStorage(): void {
  try {
    Object.values(STORAGE_KEYS).forEach(key => {
      localStorage.removeItem(key);
    });
  } catch (error) {
    console.error('Failed to clear storage:', error);
  }
}